import { CopyBlock } from '@/design-system/molecules/CopyBlock';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

const IntegrationCopyBlock = (props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);
    const classNames = props.appliedCssClassNames || '';

    // Parse table styles (can have multiple selections)
    const hasPlainTable = classNames.includes('tableStyle_plain');
    const hasStripedTable = classNames.includes('tableStyle_striped');
    const hasBorderedTable = classNames.includes('tableStyle_bordered');
    const hasCompactTable = classNames.includes('tableStyle_compact');

    return (
        <CopyBlock
            {...props}
            isToppedAlign={modifiers.alignment === 'top'}
            isRightAlign={modifiers.alignment === 'right'}
            isLeftAlign={modifiers.alignment === 'left'}
            isLargeImage={modifiers.imageSize === 'large'}
            hasPlainTable={hasPlainTable}
            hasStripedTable={hasStripedTable}
            hasBorderedTable={hasBorderedTable}
            hasCompactTable={hasCompactTable}
        />
    );
};

export default IntegrationCopyBlock;
